export default __webpack_public_path__ + "static/media/html.7130e06b.svg";